import { Tabs } from '@mantine/core';
// components
import { FolderGit2, Settings2 } from 'lucide-react';
import Drawer from '@/components/Drawer';
import AgentManagement from '@/modules/SettingsDrawer/components/AgentManagement';
import Settings from '@/modules/SettingsDrawer/components/Settings';
// icons

interface DataTransferDrawerProps {
    isOpened: boolean;
    onClose: () => void;
}

const SettingsDrawer = ({ isOpened, onClose }: DataTransferDrawerProps) => {
    return (
        <Drawer
            name="settings"
            opened={isOpened}
            position="right"
            size="sm"
            title="Settings"
            onClose={onClose}
        >
            <Tabs defaultValue="agent">
                <Tabs.List>
                    <Tabs.Tab leftSection={<FolderGit2 />} value="agent">
                        Agent Management
                    </Tabs.Tab>
                    <Tabs.Tab leftSection={<Settings2 />} value="settings">
                        Preferences
                    </Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel className="pt-4" value="agent">
                    <AgentManagement />
                </Tabs.Panel>
                <Tabs.Panel className="pt-4" value="settings">
                    <Settings />
                </Tabs.Panel>
            </Tabs>
        </Drawer>
    );
};

export default SettingsDrawer;
